import { Component, Inject, NgZone, OnInit } from '@angular/core';
import {NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../service/auth.service';
import { DatePipe, DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginModalService } from '../login-modal.service';
import { BottomContainerComponent } from "../bottom-container/bottom-container.component";
import { Summary } from "../models/summary";
import { AppConstants } from '../AppConstants';
import { UIRoutes } from '../UIRoutes';
import { CheckoutService } from 'paytm-blink-checkout-angular';
import { Subscription } from 'rxjs';
import { ICheckoutInstance } from 'paytm-blink-checkout-angular/lib/models';
import { HttpErrorResponse } from '@angular/common/http';
import { browser } from 'protractor';
import { UtilService} from '../service/util.service';
import { CapacitorPlatformService } from '../service/capacitor-platform.service';

// This lets me use jquery
declare var $: any;


export class selectedSlotObj {
           uniqueId: string;
           ss_service: string;
           ss_productId: string;
           ss_slotDate: string;
           ss_startTime: string;
           ss_endTime: string;
           amount: string;
           ss_slotId_td: string;
           ss_webAppId: number;
           ss_slotType: string;
           ss_venueId: string;
           category: string;
           ss_tenantId: string;
           userId: string;
           advanceProductId: number;
           paymentType: string;
           name: string;
           phoneNumber: string;
           email: string;
           notes: string;
           startDate:string; //for Multisession and monthly type service only
           platformFeeForSlot : number;

    constructor(uniqueId: string, venueId: string, startTime: string, endTime: string, price: string, slotId_td: string, slotType: string)
    {
      this.uniqueId = uniqueId;
      this.ss_venueId = venueId;
      this.ss_startTime = startTime;
      this.ss_endTime = endTime;
      this.amount = price;
      this.ss_slotId_td = slotId_td;
      this.ss_slotType = slotType;
      this.category = "placeholder";
      this.advanceProductId= 1;
      this.notes = "External";
    }
}

@Component({
  selector: 'app-product-landing',
  templateUrl: './product-landing.component.html',
  styleUrls: ['./product-landing.component.css']
})
export class ProductLandingComponent implements OnInit{
  // model: NgbDateStruct;

  /** bsModalRef: BsModalRef; */
  // bsModalRef: BsModalRef;


  selectedSlotsMap = new Map();
  isNativeApp = false;
  isBookingConfirmOpen = false;
  mobileCartMessage = '';
  isBillDeskPaymentActive = false;
  days = [];
  dt = new Date();
  month = this.dt.getMonth() + 1;
  year = this.dt.getFullYear();
  onSinglehide: boolean = false;

  slots: any;
  endSoltTime: any;
  slotPrice = [];
  priceArr: number;
  totalPriceArr = [];
  //categoryArr = ['Sports', 'Law Firm', 'Spa and Salon', 'Meeting Rooms', 'Counselor', 'Clinics', 'Path Lab', 'Community Halls', 'Office Spaces', 'Repairing Services', 'Others'];
  //selectedCat: any;
  selectedProduct: string;
  selectedServiceType: string; //Either Single or multi session
  selectedProductServiceTypeIconFileName: string; //used for badminton, cricket etc
  selectedProductServiceType: string;
  sessionType:string;
  noOfSessions:number;
  monthlyMultiBookingOption:string;
  monthlyMultiBookingSelectedDates: number[];


  allSlotsLength: boolean;
  totalSum: number = 0;
  totalForSlots: number  = 0;
  totalPlatformFeeForBooking = 0;
  alertMessages: any;
  //isSelected: boolean = false;

  singleBooking: any;
  finalStartTime: any;
  finalEndTime: any;
  latest_date1: any;
  quickDates: any[] = [];
  selectedQuickDate: string = '';
  bntStyle: string;
  slotDate: any;
  tenant: any;
  products: any;
  // Active addOns of the tenant, shown when "AddOns" is picked in the SERVICE dropdown.
  addOns: any[] = [];
  showAddOns = false;
  // SERVICE dropdown value prefix for addOns: 'addOn_' + product id.
  readonly ADD_ONS_OPTION = 'addOn_';
  // AddOn picked in the SERVICE dropdown (its card is shown).
  selectedAddOn: any = null;
  readonly MAX_ADD_ON_QUANTITY = 99;
  // Quantity typed on each addOn card, keyed by product id.
  addOnQuantities: { [productId: number]: number } = {};
  // AddOns added to the booking, keyed by product id. Paid together with the selected slots (BillDesk only).
  selectedAddOnsMap = new Map<number, { productId: number, productName: string, unitPrice: number, quantity: number, amount: number }>();
  totalForAddOns: number = 0;
  tenantFees:any;
  selectedProductIndex: any;
  venues: any;
  allSlots: any;
  public id: any;
  public productId: any;
  public venueId: any;
  isTotalSumZero: boolean = true;
  slotIdArr: any;
  slotId: number;
  slotIdAfterSelect: number;
  userb: any;
  user:any;
  slotsAllLength: number;
  bookedslotsLength: number = 0;
  get numberOfSlotsSelected(): number {
    return this.selectedSlotsMap.size;
  }
  toDate: any;
  maxDate:any;
  minDate:any;
  selectedStartDate: string;
  bookingSlots:any;
  datePipe: DatePipe = new DatePipe('en-US');

  categoryAndProduct: any;
  productByCat: any;
  isCatProd: boolean = true;
  //isSelectedCat: any; //"Badminton";
  thisProdId: any;
  dateChange: any;
  isSingle:boolean = true;
  Summary: Summary;
  slotsTypeNew: any;
  mainService: any;
  private subs: Subscription;
  openInPopup = true;
  isCheckoutVisible = true;
  config = {
    data: {
      confirmationId: "test1",
      amount: "1.00",
      token: "89c2446b174e4b4096ad10df8d3209dc1676880761206",
      tokenType: "TXN_TOKEN"
    },
    merchant: {
      mid: "NgXarD42151468596686",
      name: "bookingdexter.com",
      redirect: false
    },
    flow: "DEFAULT"
  }
  checkoutJsInstance: ICheckoutInstance;
  paymentResponse;
  paymentType;
  isPhoneInputRequired: boolean = false;
  showPhoneError: boolean = false;


  serviceEnquiryDate: string = '';
  serviceEnquiryTime: string = '';

  enquiryTimeSlots: string[] = [
    '5:00 AM - 6:00 AM',
    '6:00 AM - 7:00 AM',
    '7:00 AM - 8:00 AM',
    '8:00 AM - 9:00 AM',
    '9:00 AM - 10:00 AM',
    '10:00 AM - 11:00 AM',
    '11:00 AM - 12:00 PM',
    '12:00 PM - 1:00 PM',
    '1:00 PM - 2:00 PM',
    '2:00 PM - 3:00 PM',
    '3:00 PM - 4:00 PM',
    '4:00 PM - 5:00 PM',
    '5:00 PM - 6:00 PM',
    '6:00 PM - 7:00 PM',
    '7:00 PM - 8:00 PM',
    '8:00 PM - 9:00 PM',
    '9:00 PM - 10:00 PM',
    '10:00 PM - 11:00 PM',
    '11:00 PM - 12:00 PM'
  ];
  showEnquiryForm = false;


  // constructor() { }
  constructor(private authService: AuthService,
    private aRoute: ActivatedRoute, private router: Router,
    private loginModalService: LoginModalService, private readonly checkoutService: CheckoutService,
    private utilService: UtilService,
    private capacitorPlatformService: CapacitorPlatformService,
    private zone: NgZone
    /* private bottomContainerComponent: BottomContainerComponent */ ) {

        // Initialize latest_date1 with the current date
        this.latest_date1 = new Date().toISOString().split('T')[0];

        // Calculate the maximum allowable date (current date + 1 month)
        const maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 1);
        this.maxDate = maxDate.toISOString().split('T')[0];

    }

  ngOnInit() {
    this.isNativeApp = this.capacitorPlatformService.isNative();

    this.userb = JSON.parse(sessionStorage.getItem('current-user-context'));
    var date = new Date();
    this.latest_date1 = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.dateChange = this.latest_date1;
    this.setMinDate();
    this.id = this.aRoute.snapshot.paramMap.get('id');
    //console.log("Init : this.id", this.id);
    this.getTenantById(this.id);
    //console.log("Init : Tenant", this.tenant);
    this.getVenuesByIdSau(this.id);
    this.getProductByIdSau(this.id);
    this.getTenantFeeById(this.id);
    this.selectedProductIndex = 0;
    this.generateQuickDates();

    //this.selectedServiceType = this.products[this.selectedProductIndex].productType
    console.log("On Init", this.selectedServiceType);
    console.log("Init products : ", this.products);
    console.log("Date : ", this.latest_date1);
    //console.log("Product: ", this.products);
    // this.getAllSlotsByTenant(this.id, this.latest_date1, 1, "Single Session");
    //this.onDateChange(this.latest_date1);
    //this.selectedCat = this.categoryArr[0];
    if(this.totalSum == 0){
      this.isTotalSumZero = false;
    }

    this.subs  =  this.checkoutService.checkoutJsInstance$.subscribe(instance=>{
        // store this instance in some variable
        this.checkoutJsInstance = instance;
    });

    this.authService.getUserDetails(this.userb.username).subscribe({
        next: (userDetails: any) => {
        this.user = userDetails;

        console.log("Init User Details: ", this.user);
        const phone = this.user?.phoneNumber?.trim();
        const phoneRegex = /^[6-9]\d{9}$/;

        if (!phone || !phoneRegex.test(phone)) {
          this.user.phoneNumber = ''; // Ensure it's initialized for ngModel binding
          this.isPhoneInputRequired = true;
        } else {
          this.isPhoneInputRequired = false;
        }
      },
      error: (err) => {
        console.error('Error fetching user details:', err);
      }
    });


    this.authService.getConfig("payment_type").subscribe(
      (response: any[]) => {
        console.log("Payment Type: ", response);
        this.paymentResponse = response;
        this.paymentType = this.paymentResponse.propertyValue;
      },
      (error) => {
        console.log("Failed to get Payment Type: ", error);
      }
    );


  }
  getServiceTypeIcon(): string {
    return '../../assets/img/' + this.selectedProductServiceTypeIconFileName;
  }
  getCoachingIcon(): string {
    return AppConstants.DEFAULT_SERVICE_ICON;
  }

  getServiceName(serviceTypeIcon: string): string {

    return AppConstants.SERVICE_TYPE_NAMES[serviceTypeIcon]
        || serviceTypeIcon?.replace('.svg', '');
  }


  submitServiceEnquiry() {

    if (!this.serviceEnquiryDate) {
      alert('Please select preferred date');
      return;
    }

    if (!this.serviceEnquiryTime) {
      alert('Please select preferred time');
      return;
    }

    const payload = {
      customerName:
        `${this.user?.firstName || ''} ${this.user?.lastName || ''}`.trim(),

      customerEmail: this.user?.email,

      customerPhone: this.user?.phoneNumber,

      serviceName:
        this.products[this.selectedProductIndex]?.productName,

      serviceDate: this.serviceEnquiryDate,

      timeSlot: this.serviceEnquiryTime,

      tenantId: Number(this.id),

      tenantName: this.tenant?.tenantName
    };

    this.authService.submitServiceEnquiry(payload)
      .subscribe({
        next: () => {

          alert(
            'Your enquiry has been submitted successfully. The facility will contact you shortly.'
          );

          this.serviceEnquiryDate = '';
          this.serviceEnquiryTime = '';
        },
        error: (err) => {
          console.error(err);
          alert('Unable to submit enquiry. Please try again.');
        }
      });
  }

  generateQuickDates() {
    this.quickDates = [];

    const today = new Date();
    // Don't offer chips beyond the product's booking window (see getMaxBookableDate).
    const maxDate = this.getMaxBookableDate();

    for (let i = 0; i < 7; i++) {   // ✅ UP TO 7 DAYS
      const d = new Date();
      d.setDate(today.getDate() + i);

      if (d > maxDate) {
        break;   // stop once we cross the booking window
      }

      const formatted = this.datePipe.transform(d, 'yyyy-MM-dd');

      let label = '';

      if (i === 0) label = 'Today';
      //else if (i === 1) label = 'Tomorrow';
      else label = this.datePipe.transform(d, 'EEE dd');

      this.quickDates.push({
        value: formatted,
        label: label
      });
    }

    // Keep the current selection if it is still within the window, else default to the first chip.
    if (this.quickDates.length > 0) {
      const stillValid = this.quickDates.some(q => q.value === this.selectedQuickDate);
      if (!stillValid) {
        this.selectedQuickDate = this.quickDates[0].value;
      }
    }
  }
  onQuickDateSelect(date: string) {
    this.selectedQuickDate = date;
    this.latest_date1 = date;

    this.onDateChange(date);
  }
  generateQuickDatesFromSelected(selectedDate: string) {

    this.quickDates = [];

    const baseDate = new Date(selectedDate);
    const maxDate = this.getMaxBookableDate();

    for (let i = 0; i < 7; i++) {

      const d = new Date(baseDate);
      d.setDate(baseDate.getDate() + i);

      if (d > maxDate) {
        break;   // don't offer chips beyond the booking window
      }

      const formatted = this.datePipe.transform(d, 'yyyy-MM-dd');

      let label = '';

      /* if (i === 0) label = 'Selected';
      else if (i === 1) label = 'Next';
      else  */label = this.datePipe.transform(d, 'EEE dd');

      this.quickDates.push({
        value: formatted,
        label: label
      });
    }

    this.selectedQuickDate = selectedDate;
  }


  futureDates: string[] = []; // Array to store generated future dates

  generateFutureDates(): void {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // 0-indexed month
      const monthsToGenerate = 2; // Generate dates for the next 2 months
        this.futureDates.length = 0;
      // Loop through the current and next month
      for (let i = 0; i < monthsToGenerate; i++) {
        const month = currentMonth + i; // Calculate the month
        const year = currentYear + Math.floor(month / 12); // Handle year rollover
        const actualMonth = month % 12; // Adjust month to stay within 0-11 range

        // Loop through each day in X
        this.monthlyMultiBookingSelectedDates.forEach((day) => {
                console.log("Day", day);
                if (day > 0 && day <= this.daysInMonth(actualMonth, year)) {
                  const date1 = new Date(year, actualMonth, day);
                  console.log("Day", date1);
                  if (date1 > today) {
                    this.futureDates.push(date1.toLocaleDateString('en-CA')); // Store as 'YYYY-MM-DD'
                  }
                }
              });

      }

      if (this.futureDates.length > 0) {
            this.selectedStartDate = this.futureDates[0]; // Default to the first date
      }
      console.log('Generated Future Dates:', this.futureDates); // Log the dates
  }
  daysInMonth(month: number, year: number): number {
      return new Date(year, month + 1, 0).getDate(); // Get the last day of the month
  }
  getTenantFeeById(id)
  {
    this.authService.getTenantFeeById(id).subscribe(
          (response:any) => {
            this.tenantFees = response;
            this.calculateTotalFees();
            console.log(" fees", this.tenantFees);

            },
           (errorResponse) => {
             console.log("Error while retrieving fees" + errorResponse);
           }
         );
  }
  getProductByIdSau(id) {
    console.log("Saving Id", id);
    this.authService.getAllProductsByTenantId(id, true).subscribe(
      (response:any) => {
        // this.products = response;
        console.log(response);
        // AddOns are not bookable: keep them out of `products` (which drives slots) and list them separately.
        this.addOns = response.filter(product => product.status === AppConstants.STATUS_ACTIVE && product.productType === AppConstants.ADD_ONS).sort((a, b)=> a.productName.localeCompare(b.productName));
        this.products = response.filter(product => product.status === AppConstants.STATUS_ACTIVE && product.sessionType !== 'Flexible' && product.productType !== AppConstants.ADD_ONS).sort((a, b)=> a.productName.localeCompare(b.productName));

        console.log("All Products", this.products);
        if (this.products.length === 0) {
          // Nothing bookable: show the first addOn (matches the dropdown's first option) instead of loading slots.
          this.showAddOns = this.addOns.length > 0;
          this.selectedAddOn = this.addOns.length > 0 ? this.addOns[0] : null;
          return;
        }
        this.productId = this.products[0].id;
        this.selectedProduct = this.products[0].productName;
        console.log("Selected Product = ", this.products[0].productName);
        this.selectedServiceType = this.products[0].productType;  //this is Single or multi session
        this.selectedProductServiceTypeIconFileName = this.products[0].serviceType;
        this.showEnquiryForm = this.products[0]?.allowBooking === false;

        if(this.selectedServiceType  == "Multi Session")
        {
          this.sessionType = this.products[0].sessionType;
          this.monthlyMultiBookingOption = this.products[0].monthlyMultiBookingOption

          if( this.monthlyMultiBookingOption === "Selected Dates")
          {
            this.monthlyMultiBookingSelectedDates = this.parseSelectedDates(this.products[0].monthlyMultiBookingSelectedDates);
            this.generateFutureDates();
          }
          else
          {
            this.monthlyMultiBookingSelectedDates.length = 0; //clear the array for other product types
          }
          console.log("MM Settings1 : ", this.monthlyMultiBookingOption );
          console.log("MM Settings2 : ", this.monthlyMultiBookingSelectedDates );
        }
        console.log("service Type : ", this.selectedServiceType );
        this.computeBookingWindow();
        this.getAllSlotsByTenant(this.id, this.latest_date1, this.productId, this.selectedServiceType);
      },
      (errorResponse) => {
        console.log("Error while retrieving products by tenant id" + errorResponse);
      }
    );
  }
  // Function to parse and convert the string to an array of numbers
  parseSelectedDates(data: string): number[] {
    return data
      .split(',')              // Split the string by comma
      .map(date => date.trim()) // Trim any extra spaces
      .map(Number)              // Convert each element to a number
      .filter(num => !isNaN(num)); // Filter out any invalid numbers
  }
  notifyMerchantHandler = (eventType, data): void => {
    console.log('MERCHANT NOTIFY LOG', eventType, data);
  }

  transactionStatusHandler = (data): void => {
    console.log('transactionStatusHandler', data);
    this.toggleCheckout();
    // this.checkoutJsInstance.closePopup();
    // this.checkoutJsInstance.closeModal();
    // this.checkoutJsInstance.close();
    // this.checkoutJsInstance.close;

      var arrayJSon: string = '';
      for (const value of this.selectedSlotsMap.values())
      {
        //array_name.push(value);
         if (arrayJSon != '') {
            value.confirmationId = data.confirmationId
            value.paymentType = "PhonePe"
            this.addUserDetailsToSlotPayload(value);
            arrayJSon =  arrayJSon + ","  + JSON.stringify(value);
         }
         else {
          value.confirmationId = data.confirmationId
          value.paymentType = "PhonePe"
          this.addUserDetailsToSlotPayload(value);
          arrayJSon = JSON.stringify(value);
         }
      }
      arrayJSon = "[" +  arrayJSon + "]";
      console.log(arrayJSon);
      this.authService.confirmBooking(arrayJSon).subscribe(
          (response: any) => {

                this.hideModal();
                this.selectedSlotsMap.clear();
                //this.isBookingSuccessful = true;

                //alert("Booking is successful: " + response.confirmationId);
                //this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_PRODUCT_ALL);
                console.log("Booking is successful, response: ", response);
                const confirmationId = response.confirmationId;
                sessionStorage.setItem(AppConstants.CONFIRMATION_ID, confirmationId);
                this.router.navigate([UIRoutes.ROUTING_MODULE_TRANSACTION_PAYMENT_STATUS])
                  .then(() => {
                    window.location.reload();
                });
          },
          (error) => {
             //this.isBookingSuccessful = false;
             console.log("Booking failed, response: ", error);
             const confirmationId = error.confirmationId;
             sessionStorage.setItem(AppConstants.CONFIRMATION_ID, confirmationId);
             this.router.navigate([UIRoutes.ROUTING_MODULE_TRANSACTION_PAYMENT_STATUS])
                  .then(() => {
                    window.location.reload();
                });
          }
        );
  }

  ngOnDestroy(): void {
    this.stopBookingViewportTracking();
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  appendHandler(config): any {
    const newConfig = { ...config };

    newConfig.handler = {
      notifyMerchant: this.notifyMerchantHandler,
      transactionStatus: this.transactionStatusHandler
    }

    return newConfig;
  }

  toggleCheckout(): void {
    this.isCheckoutVisible = false;
  }

  getCheckout() {
    console.log("isCheckoutVisible", this.isCheckoutVisible);
    this.isCheckoutVisible;
  }

  initializeCheckout(confirmationId, txnToken, amount): void {
    this.config.data.confirmationId = confirmationId;
    this.config.data.token = txnToken;
    this.config.data.amount = amount;
    const config = this.appendHandler(this.config);
    this.isCheckoutVisible = true;
    this.checkoutService.init(config, { env: 'STAGE', openInPopup: this.openInPopup});
  }

  // openLoginModal() {
  //   this.bsModalRef = this.modalService.show(ConfirmModelComponent);
  // }

  deleteSelectedSlot(event: Event, slot: any) {

    event.stopPropagation();

    console.log("removing slot", slot);
    console.log("Map before: ", this.selectedSlotsMap);

    if (!this.selectedSlotsMap?.has(slot.key)) {
      console.log("Key not found");
      return;
    }

    // ---- SAFE NUMBERS ----
    const feeForSlot =
      Number(this.selectedSlotsMap.get(slot.key)?.platformFeeForSlot) || 0;

    const slotAmount =
      Number(slot?.value?.amount) || 0;

    const currentPlatformFee =
      Number(this.totalPlatformFeeForBooking) || 0;

    const currentTotal =
      Number(this.totalSum) || 0;

    console.log("Slot Fee", feeForSlot);

    // ---- CALCULATIONS ----
    this.totalPlatformFeeForBooking =
      Math.floor((currentPlatformFee - feeForSlot) * 10) / 10;

    this.totalSum =
      Math.floor((currentTotal - slotAmount - feeForSlot) * 10) / 10;

    this.totalForSlots = this.totalForSlots - slotAmount;

    // Prevent negatives / NaN
    if (!isFinite(this.totalPlatformFeeForBooking) || this.totalPlatformFeeForBooking < 0) {
      this.totalPlatformFeeForBooking = 0;
    }

    if (!isFinite(this.totalSum) || this.totalSum < 0) {
      this.totalSum = 0;
      this.totalForSlots = 0;
    }

    // ---- DELETE SLOT ----
    this.selectedSlotsMap.delete(slot.key);

    console.log("Map After: ", this.selectedSlotsMap);

    // ---- IF MAP EMPTY → RESET + CLOSE MODAL ----
    if (this.selectedSlotsMap.size === 0) {
      this.totalSum = 0;
      this.totalForSlots = 0;
      this.totalPlatformFeeForBooking = 0;
      if (!this.hasItemsInCart) {
        this.hideModal();   // <-- CLOSE MODAL HERE (keep it open while addOns remain)
      }
    }

    // Recompute from the cart so addOns stay included in the totals.
    this.calculateTotalFees();

    console.log("totalPlatformFeeForBooking after deleting", this.totalPlatformFeeForBooking);
    console.log("Total Fee after deleting", this.totalSum);
  }

  /* deleteSelectedSlot(event, slot){

      console.log("removing slot", slot);
      console.log("Map before: ", this.selectedSlotsMap);
      console.log("totalPlatformFeeForBooking before deleting",  this.totalPlatformFeeForBooking);
      console.log("Total Fee  before deleting",  this.totalSum);

      if(this.selectedSlotsMap.has(slot.key))
      {

        let feeForSlot = this.selectedSlotsMap.get(slot.key).platformFeeForSlot;
        console.log("Slot Fee",  feeForSlot);
        this.totalPlatformFeeForBooking = Math.floor((this.totalPlatformFeeForBooking - feeForSlot) * 10) / 10;
        this.totalSum = Math.floor((this.totalSum - slot.value.amount - feeForSlot)* 10) / 10;
        *//*    if (!this.totalPlatformFeeForBooking|| isNaN(this.totalPlatformFeeForBooking)) return this.totalPlatformFeeForBooking = 0;
          if (!this.totalSum|| isNaN(this.totalSum)) return this.totalSum = 0; *//*
         this.selectedSlotsMap.delete(slot.key);

         if (this.selectedSlotsMap.size == 0)
         {
            this.totalSum = 0;
            this.totalPlatformFeeForBooking = 0;
         }
         console.log("totalPlatformFeeForBooking after deleting",  this.totalPlatformFeeForBooking);
         console.log("Total Fee  after deleting",  this.totalSum);


      }
      else
      {
          console.log("Key not found");
      }
      console.log("Map After: ", this.selectedSlotsMap);

  } */
  calculatePlatformFee(price, serviceType): number {
    if (!this.tenantFees) {
      const defaultFee = (Number(price) || 0) * 0.02;
      return Math.floor(defaultFee * 10) / 10;
    }

    let feeValue: number;
    let feeType: string;

    // Pick the end-user fee based on product type: Single vs Monthly/Multi Session
    if (serviceType == "Single Session") {
      feeValue = this.tenantFees.singleEndUserFee;
      feeType  = this.tenantFees.singleEndUserFeeType;
    }
    else if (serviceType == "Multi Session") {
      feeValue = this.tenantFees.multiEndUserFee;
      feeType  = this.tenantFees.multiEndUserFeeType;
    }
    else {
      return 0;
    }

    const amount = Number(price) || 0;
    const fee    = Number(feeValue) || 0;

    if (feeType == "percentage") {
      return Math.floor((amount * fee / 100) * 10) / 10;
    }
    else if (feeType == "absolute") {
      return Math.floor(fee * 10) / 10;
    }

    return 0;
  }

  calculateAddOnPlatformFee(amount: number, quantity: number): number {
    if (!this.tenantFees) {
      const defaultFee = (Number(amount) || 0) * 0.02;
      return Math.floor(defaultFee * 10) / 10;
    }

    const addOnAmount = Number(amount) || 0;
    const addOnQuantity = Math.max(1, Number(quantity) || 1);
    const feeValue = Number(this.tenantFees.singleEndUserFee) || 0;
    const feeType = String(this.tenantFees.singleEndUserFeeType || '').toLowerCase();
    let rawFee = 0;

    if (feeType === 'percentage' || feeType === '%') {
      rawFee = ((addOnAmount / addOnQuantity) * feeValue) / 100 * addOnQuantity;
    } else if (feeType === 'absolute') {
      rawFee = feeValue * addOnQuantity;
    }

    return Math.floor(rawFee * 10) / 10;
  }

  getTenantById(id) {
    this.authService.getSauByTenantId(id).subscribe(
      (response) => {

        this.tenant = response;
        console.log("In getTenantById ", this.tenant);
      },
      (errorResponse) => {
        console.error("Failed to load tenant by id" + errorResponse);
      }
    );
  }


  getVenuesByIdSau(id) {
    var tempData = [];
    console.log("getVenuesByIdSau 1", id);
    this.authService.getAllVenuesByTenantId(id).subscribe(
      (response: any[]) => {
        console.log("getVenuesByIdSau 2", response);
        for(var i=0; i < Object.keys(response).length; i++){
          const venueObj = {
            venueType: response[i].venueType,
          }

          const found = tempData.filter(x => x.venueType == response[i].venueType)[0]
          if(!found){
            tempData.push(venueObj)
          }
        }

        this.venues = tempData;


      },
      (errorResponse) => {
        console.error("Error while retrieving venues by tenantId" + errorResponse);
      }
    );
  }


  getAllSlotsByTenant(id, latest_date1, productId, serviceType) {
      // Get slots by time sorted
      console.log("getAllSlotesByTenant ", serviceType );
      console.log("getAllSlotesByTenant  this.thisProdId ", this.thisProdId );
      this.getTimeWiseSlots(id, latest_date1, productId, '', serviceType);
  }

  getDaysInMonth(month, year) {
    month = this.dt.getMonth() + 2;

    return this.days;
  }


  days12 = this.getDaysInMonth(this.month, this.year);

/*
  singleOrRecuringBook(book): void {
    if(book == 'rec'){
      this.onSinglehide = true;
    } else {
      this.onSinglehide = false;
    }
  }
 */


  isLoggedIn() {
    if(sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT)) {
      console.log("External user", sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT));
      return true;
    } else if(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)) {
      console.log("Current user", sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT));
      return true;
    }
    else
    {
      console.log("Current user 2");
    }
  }

  getSlotBGColor(uniqueId)
  {
      if(this.selectedSlotsMap.has(uniqueId))
      {
        return '#20D45C';
      }
      else
      {
        return "white";
      }

  }


getSlotsDetails_TD(event, uniqueId, venueId, time, endTime, price, slotId_td, slotsType, mainService)
{

    // TD_Review Start
    if(!this.isLoggedIn())
    {
      console.log("Logged Out");
      this.loginModalService.setLoginModalData(true);
      this.router.navigate(['/login'])
    }
    else
    {
      this.userb = JSON.parse(sessionStorage.getItem('current-user-context'));
      console.log("Logged in");
      console.log(this.userb);

      // TD_Review End

      let key = uniqueId;
      let platformFeeForSlot = this.calculatePlatformFee(price,this.selectedServiceType);
      if(this.selectedSlotsMap.has(key)){
        this.selectedSlotsMap.delete(key);

        //this.totalPlatformFeeForBooking = this.totalPlatformFeeForBooking - platformFeeForSlot;
        //this.totalSum = this.totalSum - price - platformFeeForSlot;
        this.calculateTotalFees();
        //this.totalForSlots = this.totalForSlots - price;
        console.log(this.totalSum);
        console.log('removed');

      } else {

        this.mobileCartMessage = '';
        let selectedSlot = new selectedSlotObj(uniqueId, venueId, time, endTime, price, slotId_td, slotsType);
        //console.log("selected Service : ", this.selectedProduct);
        selectedSlot.ss_service = this.selectedProduct;
        selectedSlot.ss_productId = this.productId; // service and product are same.
        selectedSlot.ss_slotDate = this.datePipe.transform(this.dateChange, 'd MMM y');
        selectedSlot.userId = this.userb.userId;
        selectedSlot.platformFeeForSlot = this.calculatePlatformFee(price,this.selectedServiceType);
        console.log("platformFeeForSlot", selectedSlot.platformFeeForSlot);
        if(this.sessionType === "Monthly")
        {
          selectedSlot.startDate = this.selectedStartDate;
          console.log("selected startDate : ", this.selectedStartDate);
        }
        //selectedSlot.ss_venueId = this.venueId;
        console.log(slotsType+ this.dateChange+time);

        //Adding into the map of selected slots.
        this.selectedSlotsMap.set(key, selectedSlot);

        console.log("added slot", this.selectedSlotsMap);
        console.log("Added");
        this.calculateTotalFees();
        //this.totalPlatformFeeForBooking = this.totalPlatformFeeForBooking + selectedSlot.platformFeeForSlot;
        //this.totalSum = this.totalSum + price + selectedSlot.platformFeeForSlot;
        //this.totalForSlots = this.totalForSlots + price;
        console.log(this.totalSum);

      }
      if(this.totalSum == 0){
        this.isTotalSumZero = false;
      }
      else
      {
        this.isTotalSumZero = true;
      }

    }
}


getAddOnQuantity(addOn: any): number {
  const quantity = this.addOnQuantities[addOn.id];
  return quantity != null ? quantity : (this.selectedAddOnsMap.get(addOn.id)?.quantity || 1);
}

changeAddOnQuantity(addOn: any, change: number): void {
  const quantity = Number(this.getAddOnQuantity(addOn));
  const currentQuantity = Number.isFinite(quantity) ? Math.trunc(quantity) : 1;
  this.addOnQuantities[addOn.id] = Math.min(this.MAX_ADD_ON_QUANTITY, Math.max(1, currentQuantity + change));
}

/** Book Now is allowed with slots, addOns, or both. */
get hasItemsInCart(): boolean {
  return this.selectedSlotsMap.size > 0 || this.selectedAddOnsMap.size > 0;
}

addAddOnToBooking(addOn: any): void {
  // Same as selecting a slot: booking needs a logged-in user.
  if (!this.isLoggedIn()) {
    this.loginModalService.setLoginModalData(true);
    this.router.navigate(['/login']);
    return;
  }
  const quantity = Number(this.getAddOnQuantity(addOn));
  if (!Number.isInteger(quantity) || quantity < 1 || quantity > this.MAX_ADD_ON_QUANTITY) {
    alert(`Please enter a quantity between 1 and ${this.MAX_ADD_ON_QUANTITY}.`);
    return;
  }
  const unitPrice = Number(addOn.price) || 0;
  this.selectedAddOnsMap.set(addOn.id, {
    productId: addOn.id,
    productName: addOn.productName,
    unitPrice: unitPrice,
    quantity: quantity,
    amount: Math.round(unitPrice * quantity * 100) / 100
  });
  this.addOnQuantities[addOn.id] = quantity;
  this.calculateTotalFees();
}

removeAddOnFromBooking(productId: number): void {
  this.selectedAddOnsMap.delete(productId);
  delete this.addOnQuantities[productId];
  this.calculateTotalFees();
  if (!this.hasItemsInCart) {
    this.hideModal();
  }
}

calculateTotalFees(): void {

  let totalSlotAmount = 0;
  let totalPlatformFee = 0;

  if (this.selectedSlotsMap && this.selectedSlotsMap.size > 0) {

    this.selectedSlotsMap.forEach((selectedSlot: any) => {

      const slotPrice = Number(selectedSlot.amount) || 0;
      const platformFee = Number(selectedSlot.platformFeeForSlot) || 0;

      totalSlotAmount += slotPrice;
      totalPlatformFee += platformFee;
    });
  }
  this.totalForSlots = totalSlotAmount;

  this.totalPlatformFeeForBooking = totalPlatformFee;

  let totalAddOnAmount = 0;
  this.selectedAddOnsMap.forEach(addOn => {
    totalAddOnAmount += addOn.amount;
    totalPlatformFee += this.calculateAddOnPlatformFee(addOn.amount, addOn.quantity);
  });
  this.totalForAddOns = Math.round(totalAddOnAmount * 100) / 100;
  this.totalPlatformFeeForBooking = Math.floor(totalPlatformFee * 10) / 10;

  // Final Total = Slot Total + Platform Fee Total + AddOns Total
  this.totalSum = Math.round((totalSlotAmount + totalPlatformFee + this.totalForAddOns) * 100) / 100;
}

checkIfDateIsLaterThanMonth(dateToCheck: Date): boolean {
  // Compare against the currently selected product's booking window (see computeBookingWindow).
  return dateToCheck > this.getMaxBookableDate();
}

/**
 * Latest date the selected product can be booked for.
 * Single-session products may configure the window ('UptoDate' or 'RollingDays'); everything
 * else (and any product without a configured window) falls back to the legacy 1-month window.
 */
getMaxBookableDate(): Date {
  const product = this.products ? this.products[this.selectedProductIndex] : null;
  const isSingle = product && product.productType === 'Single Session';

  let maxDate: Date;
  if (isSingle && product.bookingWindowType === 'UptoDate' && product.bookingWindowValue) {
    maxDate = new Date(product.bookingWindowValue);
  } else if (isSingle && product.bookingWindowType === 'RollingDays' && product.bookingWindowValue) {
    maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + Number(product.bookingWindowValue));
  } else {
    // Legacy default: 1 month from today.
    maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1);
  }
  maxDate.setHours(23, 59, 59, 999);
  return maxDate;
}

/** Refresh the date-picker max bound from the selected product's booking window. */
computeBookingWindow(): void {
  this.maxDate = this.getMaxBookableDate().toISOString().split('T')[0];
  // Rebuild the quick-date chips now that the window is known (ngOnInit runs before products load).
  this.generateQuickDates();
}


  timeSlotsArr = [];
  slotDay: any;
  removeSlotArr = [];
  subArrNew: any = [];
  courtArr: any = [];
  mainserviceArr: any = [];
  mainserviceArrFinal: any = [];
  filnalCourtArr: any = [];
  newRecord: boolean;
  newSubRecord: boolean = true;
  isSlotBooked: boolean = false;
  finalSlotsArr = [];
  isVisible: boolean = true;
  isSelectedSlot: boolean = false;
  summaryPanel: any;


  deepSearch (object, key, predicate) {
    if (object.hasOwnProperty(key) && predicate(key, object[key]) === true) return object

    for (let i = 0; i < Object.keys(object).length; i++) {
      let value = object[Object.keys(object)[i]];
      if (Object.keys(object)[i] === key && value != null) {
        let o = object[Object.keys(object)[i]];
        if (o != null) return o
      }
    }
    return null
  }

  getSelecteDropdownText(prod_ID) {

    for(var i = 0; i < this.products.length; i++){
      if(prod_ID == this.products[i].id){
        var productIndex = i;
      }
    }
    console.log("i", productIndex);
    return productIndex;

  }

  onChangeService(service) {
    console.log("service : ", service);
    //this.thisProdId = service;
    this.showEnquiryForm = false;
    console.log()

    // An addOn picked in the dropdown: show its card instead of dates and slots.
    if (typeof service === 'string' && service.startsWith(this.ADD_ONS_OPTION)) {
      const addOnId = Number(service.substring(this.ADD_ONS_OPTION.length));
      this.selectedAddOn = this.addOns.find(addOn => addOn.id === addOnId) || null;
      this.showAddOns = true;
      this.selectedServiceType = AppConstants.ADD_ONS;
      this.allSlots = [];
      return;
    }
    this.showAddOns = false;
    this.selectedAddOn = null;


    this.newRecord = true
    this.selectedProductIndex = this.getSelecteDropdownText(service);
    this.selectedProduct = this.products[this.selectedProductIndex].productName;
    this.selectedServiceType = this.products[this.selectedProductIndex].productType;
    this.sessionType = this.products[this.selectedProductIndex].sessionType;
    this.selectedProductServiceTypeIconFileName = this.products[this.selectedProductIndex].serviceType;

    if (
          this.products[this.selectedProductIndex]?.productType === 'Multi Session' &&
          this.products[this.selectedProductIndex]?.allowBooking === false
        ) {
          this.showEnquiryForm = true;
    }


    if(this.selectedServiceType  == "Multi Session")
    {
      this.monthlyMultiBookingOption = this.products[this.selectedProductIndex].monthlyMultiBookingOption

      if( this.monthlyMultiBookingOption === "Selected Dates")
      {
        this.monthlyMultiBookingSelectedDates = this.parseSelectedDates(this.products[this.selectedProductIndex].monthlyMultiBookingSelectedDates);
        console.log("selected dates",this.monthlyMultiBookingSelectedDates );
        this.generateFutureDates();
      }
      else
      {
        this.monthlyMultiBookingSelectedDates.length = 0; //clear the array for other product types
      }
      console.log("MM Settings1 : ", this.monthlyMultiBookingOption );
      console.log("MM Settings2 : ", this.monthlyMultiBookingSelectedDates );

    }
    console.log("onChangeService Selected service", this.products[this.selectedProductIndex]);
    this.computeBookingWindow();
    // Get slots by time sorted
    this.getTimeWiseSlots(this.id, this.dateChange, this.products[this.selectedProductIndex].id, this.selectedProduct, this.products[this.selectedProductIndex].productType);

  }



  onStartDateChange(startDate: string) {
    console.log('Selected session count:', startDate);
    this.selectedStartDate = startDate;
    console.log('selectedStartDate', this.selectedStartDate);
    // Handle the change in session count as needed
  }
  setMinDate() {
      const today = new Date();
      this.minDate = today.toISOString().split('T')[0]; // Format: 'yyyy-MM-dd'
  }

  // Get time string convert into time
  convertStringTimetoDateTime(dStr,format) {
    var now = new Date();
    var newNow;
    if (format == "h:m") {
       now.setHours(dStr.substr(0,dStr.indexOf(":")));
       now.setMinutes(dStr.substr(dStr.indexOf(":")+1));
       now.setSeconds(0);
       newNow = now.getHours()+":"+now.getMinutes()+"0";
       return newNow;
    }else
      return "Invalid Format";
  }
  onDateChange(dateChange: string) {

    // ✅ Update selected date
    this.dateChange = dateChange;
    this.latest_date1 = dateChange;

    // ✅ Sync with date roller (highlight selected chip)
    this.selectedQuickDate = dateChange;

    // ✅ If selected date is NOT in current 7-day roller → regenerate
    const exists = this.quickDates.find(d => d.value === dateChange);

    if (!exists) {
      this.generateQuickDatesFromSelected(dateChange);
    }

    console.log("onDateChange:", dateChange);
    console.log("Selected Product Index:", this.selectedProductIndex);
    console.log("Selected Product:", this.products[this.selectedProductIndex]);

    // ✅ Load slots (your existing logic)
    this.getTimeWiseSlots(
      this.id,
      dateChange,
      this.products[this.selectedProductIndex].id,
      '',
      this.products[this.selectedProductIndex].productType
    );


    const selectedProduct =
      this.products[this.selectedProductIndex];

    if (selectedProduct?.allowBooking === false) {

      this.serviceEnquiryDate = dateChange;

      this.showEnquiryForm = true;
    }
  }

  clearDate() {
      this.toDate = '';

      console.log("Clear Date");
  }

  // format date in typescript
  getFormatedDate(date: Date, format: string) {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, format);
  }

  round(value, decimals) {
    return Number(Math.round(Number(value) + Number(decimals)) +'e-'+ decimals).toFixed(decimals);
  }


  /* element2: any;
  timeSlot: any;
  removeSlotItem(event, price, slotIndex): void {
      var thisId = event.currentTarget.id;
      var slotIds = thisId.split("_");
      this.removeSlotArr.shift();
      this.element2 = document.getElementById('slotRow_'+slotIndex);
      this.timeSlot = document.getElementById('slot_'+slotIds[1]);
      this.element2.classList.add('slot_deleted');
      this.timeSlot.classList.remove('slot_selected');

      var yorBookingEle = document.getElementById('your_booking');


      if(this.removeSlotArr.length == 0){
        yorBookingEle.classList.remove('slot_selected');
      }

      this.totalSum = Number(this.totalSum) - Number(price);
      if(this.totalSum == 0){
        this.isTotalSumZero = false;
      }

      this.bookedslotsLength = this.removeSlotArr.length;
      if(this.removeSlotArr.length == 0){
        this.timeSlotsArr = [];
      }
  } */



  bookSlots(event, selectValue, selectService): void {

    let user = JSON.parse(sessionStorage.getItem('current-user-context'));

    let singleObj = {
      startTime: this.finalStartTime,
      endTime: this.finalEndTime,
      bookingDate: this.slotDate,
      amount: this.totalSum,
      category: "Placeholder",
      tenantId: Number(this.id),
      venueId: this.venueId,
      userId: user.userId,
      productId: this.productId,
      advanceProductId: 1
    }


    // this.authService.singleBookingRequestToServer(singleObj, 1).subscribe(
    //   (response) => {
    //

    //     this.singleBooking = response;
    //   },
    //   (error) => {

    //   }
    // );-
  }

  numberLength(number) {
    let length = 0;
    let n = Math.abs(number);
    do {
      n /= 10;
      length++;
    } while (n >= 1);
    return length;
  }

  selectDays(event){
  }

  displayStyle = "none";

  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }

   showModal():void {
    if (this.isNativeApp && this.selectedSlotsMap.size === 0) {
      this.mobileCartMessage = 'Your cart is empty. Add a slot to continue.';
      return;
    }

    this.updateBookingViewport();
    window.visualViewport?.addEventListener('resize', this.updateBookingViewport);
    window.visualViewport?.addEventListener('scroll', this.updateBookingViewport);
    $("#myModal").modal('show');
    this.isBookingConfirmOpen = true;
    $("#myModal").off('hidden.bs.modal.bookingViewport').on('hidden.bs.modal.bookingViewport', () => {
      this.stopBookingViewportTracking();
    });
  }

  isUpdatingPhone: boolean = false;

  private updateBookingViewport = (): void => {
    const viewport = window.visualViewport;
    const modal = document.getElementById('myModal');
    if (viewport && modal) {
      modal.style.setProperty('--booking-viewport-height', `${viewport.height}px`);
      modal.style.setProperty('--booking-viewport-top', `${viewport.offsetTop}px`);
    }
  };

  private stopBookingViewportTracking(): void {
    window.visualViewport?.removeEventListener('resize', this.updateBookingViewport);
    window.visualViewport?.removeEventListener('scroll', this.updateBookingViewport);
    $("#myModal").off('hidden.bs.modal.bookingViewport');
  }

  updatePhoneNumber() {
    const phone = this.user.phoneNumber?.trim();
    const userParams = {
      firstName: this.user.firstName,
            lastName: this.user.lastName,
            phoneNumber: phone
    };

    this.authService.updateUserDetails(userParams, this.user.id).subscribe({
      next: () => {
        this.user.phoneNumber = phone;
        this.isPhoneInputRequired = false;
        this.isUpdatingPhone = false;
      },
      error: () => {
        this.isUpdatingPhone = false;
      }
    });
  }

  private addUserDetailsToSlotPayload(slot: any): void {
    const firstName = this.user?.firstName || '';
    const lastName = this.user?.lastName || '';

    slot.name = `${firstName} ${lastName}`.trim();
    slot.phoneNumber = this.user?.phoneNumber?.trim();
    slot.email = this.user?.email;
  }


  /* showModal(): void {
    this.userb = JSON.parse(sessionStorage.getItem('current-user-context'));
    this.authService.getUserDetails(this.userb.username).subscribe({
      next: (userDetails: any) => {
        this.user = userDetails;
        const askPhoneAndProceed = () => {
          const phone = prompt("Please enter your phone number:", "");

          if (phone === null) {
            return;
          }

          if (!/^\d{10}$/.test(phone)) {
            alert("Invalid phone number. Please enter a valid 10-digit phone number.");
            askPhoneAndProceed();
            return;
          }

          const userParams = {
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            phoneNumber: phone
          };

          this.authService.updateUserDetails(userParams, userDetails.id).subscribe({
            next: () => {
              this.user.phoneNumber = phone;
              this.openBookingModal();
            },
            error: () => {
              alert("Failed to update phone number. Please try again later.");
            }
          });
        };

        if (!userDetails.phoneNumber) {
          askPhoneAndProceed();
        } else {
          this.openBookingModal();
        }
      },
      error: () => {
        this.closeModal();
        alert("Failed to retrieve user details. Please try again later.");
      }
    });
  } */

  openBookingModal(): void {
    $("#myModal").modal('show');
    setTimeout(() => {
      $(".modal-backdrop").remove();
    }, 100);
  }


  hideModal():void {
    // document.getElementById('close-modal').click();
    $("#myModal").modal('hide');
    this.isBookingConfirmOpen = false;
  }

  closeModal():void {
      // document.getElementById('close-modal').click();
      $("#myModal").modal('close');
    }

  unique = (value, index, self) => {
    return self.indexOf(value) === index
  }
  timeTo12HrFormat(time){   // Take a time in 24 hour format and format it in 12 hour format
      var time_part_array = time.split(":");
      var ampm = 'AM';

      if (time_part_array[0] >= 12) {
          ampm = 'PM';
      }

      if (time_part_array[0] > 12) {
          time_part_array[0] = time_part_array[0] - 12;
      }

      var formatted_time = time_part_array[0] + ':' + time_part_array[1] + ' ' + ampm;

      return formatted_time;
  }
  // get time wise slots array combined

  getTimeWiseSlots(id, dateChange, thisProdId, selectText, serviceType) {

    var arraySlotsAndType: any = [];

    this.allSlots = [];
    var combineSlots: any = [];
    var toCompare = new Date(`1970-01-01T12:00:00`);
    var toCompare6 = new Date(`1970-01-01T18:00:00`);
    this.dateChange = dateChange;
    console.log("getTimeWiseSlots", serviceType);
    //this.authService.getSlotsSauByTenantId(id, this.isSelectedCat, dateChange, thisProdId).subscribe(

    const dateToCheck = new Date(this.dateChange);
    console.log("4 This Datechange", this.dateChange);
    console.log("4 dateToCheck", dateToCheck);
    console.log("4 TrueorFalse", this.checkIfDateIsLaterThanMonth(dateToCheck));
    if(this.checkIfDateIsLaterThanMonth(dateToCheck))
    {
      this.allSlots.length = 0;
      console.log("Slots Cleared");
    }
    else
    {
      this.authService.getSlotsSauByTenantId(id, dateChange, thisProdId, serviceType).subscribe(
      (response) => {
        this.allSlots = response;
        //console.log("allslots : ", this.allSlots);
        for(var i = 0; i < this.allSlots.length; i++){
          var before12 = [];
          var bwtn12To6 = [];
          var after6 = [];
          if(this.allSlots[i].timeslotWiseProducts.length > 0){

              for(var j=0; j < this.allSlots[i].timeslotWiseProducts.length; j++){
                if(!arraySlotsAndType.includes(this.allSlots[i].venueName)){
                  arraySlotsAndType.push(this.allSlots[i].venueName);
                  var newObj = {
                    mainService: selectText,
                    type: this.allSlots[i].venueName,
                    // timeslotWiseProducts: new Object,
                  }
                }
                //console.log("newobj : ", newObj);
                if(arraySlotsAndType.includes(this.allSlots[i].venueName)){
                  const parts = this.allSlots[i].timeslotWiseProducts[j].startTime.split(':');
                  const hour = parts[0].padStart(2, '0');
                  const minute = parts[1];
                  const temp = new Date(`1970-01-01T${hour}:${minute}:00`);
                  //console.log( temp + "and" + toCompare + toCompare6);
                  if(temp < toCompare){
                    this.allSlots[i].timeslotWiseProducts[j].startTime = this.timeTo12HrFormat(this.allSlots[i].timeslotWiseProducts[j].startTime);
                    this.allSlots[i].timeslotWiseProducts[j].endTime = this.timeTo12HrFormat(this.allSlots[i].timeslotWiseProducts[j].endTime);
                    //console.log("selected : ",this.allSlots[i].timeslotWiseProducts[j].selected);
                    //console.log("Adding " + this.allSlots[i].timeslotWiseProducts[j].startTime + "to before12");
                    //console.log("uid",this.allSlots[i].timeslotWiseProducts[j].uniqueId);
                    //console.log("selectedslotMap", this.selectedSlotsMap);
                    //console.log("Conv Time: ", this.allSlots[i].timeslotWiseProducts[j].startTime);
                    before12.push(this.allSlots[i].timeslotWiseProducts[j]);
                    newObj['before12'] = before12;
                    //console.log("before12: ", before12);
                    // newObj.timeslotWiseProducts['before12'] = before12.filter(this.unique);
                  } else if(temp >= toCompare && temp < toCompare6){
                    console.log("Adding " + this.allSlots[i].timeslotWiseProducts[j].startTime + "to bwtn12To6");
                    this.allSlots[i].timeslotWiseProducts[j].startTime = this.timeTo12HrFormat(this.allSlots[i].timeslotWiseProducts[j].startTime);
                    this.allSlots[i].timeslotWiseProducts[j].endTime = this.timeTo12HrFormat(this.allSlots[i].timeslotWiseProducts[j].endTime);
                    bwtn12To6.push(this.allSlots[i].timeslotWiseProducts[j]);
                    newObj['bwtn12To6'] = bwtn12To6;
                    // newObj.timeslotWiseProducts['bwtn12To6'] = bwtn12To6.filter(this.unique);
                  } else {
                    console.log("Adding " + this.allSlots[i].timeslotWiseProducts[j].startTime + "to after6");
                    this.allSlots[i].timeslotWiseProducts[j].startTime = this.timeTo12HrFormat(this.allSlots[i].timeslotWiseProducts[j].startTime);
                    this.allSlots[i].timeslotWiseProducts[j].endTime = this.timeTo12HrFormat(this.allSlots[i].timeslotWiseProducts[j].endTime);
                    after6.push(this.allSlots[i].timeslotWiseProducts[j]);
                    newObj['after6'] = after6;
                    // newObj.timeslotWiseProducts['after6'] = after6.filter(this.unique);
                  }

                }

              }

              combineSlots.push(newObj);
          }

        }

        // this.allSlots = response;
        this.allSlots = combineSlots;
        this.allSlotsLength = (this.allSlots.length > 0) ? true : false;
        //

        // return combineSlots;
      },
      (error) => {

        }
     );
    }
  }

  cancelSlots(): void {
    this.mainserviceArrFinal = [];
    this.router.navigate(['/product-list/'+this.id]);
  }

    // Get browser details
    getBrowserDetails(): any {
      const userAgent = navigator.userAgent;
      const language = navigator.language || (navigator as any).userLanguage;
      const screenHeight = screen.height;
      const screenWidth = screen.width;
      const colorDepth = screen.colorDepth;
      const timezoneOffset = new Date().getTimezoneOffset();
      const jsEnabled = (typeof window !== "undefined" && typeof document !== "undefined") ? "true" : "false";

      // Constructing the JSON object
      const browserDetails = {
        user_agent: userAgent,
        browser_tz: timezoneOffset.toString(),
        browser_color_depth: colorDepth.toString(),
        browser_screen_height: screenHeight.toString(),
        browser_screen_width: screenWidth.toString(),
        browser_language: language,
        browser_javascript_enabled: jsEnabled
      };

      return browserDetails;
    }


  confirmBooking(){

    const phoneRegex = /^[6-9]\d{9}$/;

    if (this.isPhoneInputRequired && (!this.user.phoneNumber || !phoneRegex.test(this.user.phoneNumber))) {
      this.showPhoneError = true;
      return;
    }
    this.updatePhoneNumber();
    this.showPhoneError = false;

    if (!this.hasItemsInCart) {
      alert("Add slots or an Add-On to the cart");
    } else {
      var arrayJSon: string = '';
      for (const value of this.selectedSlotsMap.values()){
         if (arrayJSon != '') {
            value.paymentType = this.paymentType;
            this.addUserDetailsToSlotPayload(value);
            arrayJSon =  arrayJSon + ","  + JSON.stringify(value);
         } else{
            value.paymentType = this.paymentType;
            this.addUserDetailsToSlotPayload(value);
            arrayJSon = JSON.stringify(value);
         }
      }
      arrayJSon = "[" +  arrayJSon + "]";
      console.log("Array json pl => ", arrayJSon);

      const addOns = Array.from(this.selectedAddOnsMap.values())
        .map(addOn => ({ productId: addOn.productId, quantity: addOn.quantity }));

      if(this.paymentType === "PhonePe" && this.selectedSlotsMap.size === 0) {
        alert("Please add slots to the cart");
        return;
      }

      if(this.paymentType === "PhonePe" && addOns.length > 0) {
        alert("Add-On items can only be paid online through BillDesk. Please remove the Add-On items to continue.");
        return;
      }

      if(this.paymentType === "PhonePe") {
        this.authService.initiatePayApi(arrayJSon).subscribe(
          (response: any) => {
            console.log("Initiate pay api response => ", response);
            const redirectUrl = response.txnToken;
            const confirmationId = response.confirmationId;
            sessionStorage.setItem("bookingObj", arrayJSon);
            window.location.href=redirectUrl;

            // const txtToken = response.txnToken;
            // const confirmationId = response.confirmationId;
            // const amount = response.amount;
            // console.log("txtToken: " + txtToken + "confirmationId: " + confirmationId);
            // this.initializeCheckout(confirmationId, txtToken, amount);
            // console.log("Initiate checkout done");
            // this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_TRANSACTION_PAYMENT_STATUS);
            // this.authService.confirmBooking(arrayJSon).subscribe(
            //   (response: any) => {
            //         console.log("Booking response => ", response);

            //         this.hideModal();
            //         this.selectedSlotsMap.clear();
            //         //this.isBookingSuccessful = true;

            //         alert("Booking is successful: " + response.confirmationId);
            //         this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_PRODUCT_ALL);

            //   },
            //   (error) => {
            //      //this.isBookingSuccessful = false;

            //      console.log("CB Response: ", error);
            //      alert("Booking Failed: ");
            //   }

            // );
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            if(error.error[0].bookingStatus == 'Unavailable') {
              this.hideModal();
              alert("selected slots are unavailable");
            }
          }
        );
      } else {

        console.log("Browser info : ", this.getBrowserDetails())
        const request = {
          bookingRequest : JSON.parse(arrayJSon),
          browserInfo : this.getBrowserDetails(),
          // Prices are recomputed by the backend from the stored addOn prices.
          addOns : addOns
        }
        // BillDesk
        this.authService.initiateBillDeskPayment(request).subscribe(
          (response: any) => {
            console.log("Response ", response);

            let bdOrderId = response.bdOrderId;
            let merchantId = response.mercid;
            const orderId = response.orderId || response.orderid || response.confirmationId || response.bookingId;
            let rdata = response.rdata;
            //window.location.href = `${response.url}?bdOrderId=${bdOrderId}&merchantId=${merchantId}&rdata=${rdata}`;

            var flow_config = this.utilService.billDeskFlowConfig(response);
            let image = "/assets/img/Logo.svg"
            var config = {
              responseHandler: (txn) => {
                console.log("callback received status:: ", txn)
                if(String(txn.status) === '111' || String(txn.terminal_state) === '111') {
                  console.log("Transaction terminated.")
                  this.setBillDeskPaymentActive(false);
                  const terminationStatus = String(txn.status) === '111' ? txn.status : txn.terminal_state;
                  this.authService.terminateBillDeskTransaction(terminationStatus, orderId).subscribe(
                    (terminationResponse: any) => {
                      console.log(terminationResponse);
                      this.navigateToPaymentStatus(orderId);
                    },
                    () => {
                      this.navigateToPaymentStatus(orderId);
                    }
                  );
                  return;
                }

                this.setBillDeskPaymentActive(false);
                this.navigateToPaymentStatus(orderId);
              },
              merchantLogo: image,
              flowConfig: flow_config,
              flowType: "payments"
            };
            this.setBillDeskPaymentActive(true);
            this.hideModal();
            this.utilService.launchBillDeskSdk(config);
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.setBillDeskPaymentActive(false);
            if(error.error[0] && error.error[0].bookingStatus == 'Unavailable') {
              this.hideModal();
              alert("selected slots are unavailable");
            } else {
              alert("Payment gateway failed. Please try again or after some time!!!!");
            }
          }
        )
      }

      //DO NOT REMOVE: Used for Paytm Integration
      // this.authService.initiateTransaction(arrayJSon).subscribe(
      //   (response: any) => {
      //     console.log("Initiate Transaction response => ", response);
      //     const txtToken = response.txnToken;
      //     const confirmationId = response.confirmationId;
      //     const amount = response.amount;
      //     console.log("txtToken: " + txtToken + "confirmationId: " + confirmationId);
      //     this.initializeCheckout(confirmationId, txtToken, amount);
      //     console.log("Initiate checkout done");
      //     // this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_TRANSACTION_PAYMENT_STATUS);
      //     // this.authService.confirmBooking(arrayJSon).subscribe(
      //     //   (response: any) => {
      //     //         console.log("Booking response => ", response);

      //     //         this.hideModal();
      //     //         this.selectedSlotsMap.clear();
      //     //         //this.isBookingSuccessful = true;

      //     //         alert("Booking is successful: " + response.confirmationId);
      //     //         this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_PRODUCT_ALL);

      //     //   },
      //     //   (error) => {
      //     //      //this.isBookingSuccessful = false;

      //     //      console.log("CB Response: ", error);
      //     //      alert("Booking Failed: ");
      //     //   }

      //     // );
      //   }
      // );
    }
  }

  private navigateToPaymentStatus(confirmationId: string): void {
    this.zone.run(() => {
      this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_TRANSACTION_PAYMENT_STATUS + confirmationId);
    });
  }

  private setBillDeskPaymentActive(isActive: boolean): void {
    this.isBillDeskPaymentActive = isActive;

    if (isActive) {
      document.body.classList.add('billdesk-payment-active');
      return;
    }

    document.body.classList.remove('billdesk-payment-active');
  }
}
